<div class="row mb-4">
  <div class="col-12" [ngClass]="displaySummaryDetails ? 'col-md-12' : 'col-md-7'">
    <div class="card mt-1" id="fundSummary">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-12 col-md-9">
            <h3>
              <span>
                {{ "DASHBOARD.FUND" | translate }}
                <span class="text-light">{{ "GENERICS.SUMMARY" | translate }}</span>
              </span>
              <small class="ml-md-2" *ngIf="!intradayData">
                <em class="text-light">
                  {{ "GENERICS.TIMER_MESSAGE" | translate }}: {{ counterMessage }} {{ "GENERICS.SECONDS" | translate }}
                </em>
              </small>
            </h3>
          </div>
          <div class="col-12 col-md-3 text-md-right">
            <button type="button" class="btn" [ngClass]="displaySummaryDetails ? 'btn-teal' : 'btn-outline-teal'"
                    (click)="displaySummaryDetails = !displaySummaryDetails">
              {{ (displaySummaryDetails ? "GENERICS.HIDE_DETAILS" : "GENERICS.SHOW_DETAILS") | translate }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <form class="capital-available col-12 col-md-12">
          <label class="capital-available-header">Capital Available</label>
          <label class="capital-available-label">PB Adj. Excess:</label>
          <input *ngIf="editingCapitalAvailable" [(ngModel)]="capitalAvailable.pbAdjExcess" name="pbAdjExcess"
                 class="capital-available-input">
          <span *ngIf="!editingCapitalAvailable" [innerHTML]="capitalAvailable.pbAdjExcess | rmsRoundRawNumber"></span>
          <label class="capital-available-label">|</label>
          <label class="capital-available-label">Avail. for New Investments:</label>
          <input *ngIf="editingCapitalAvailable" [(ngModel)]="capitalAvailable.availableForNewInvestments"
                 name="availableForNewInvestments" class="capital-available-input">
          <span *ngIf="!editingCapitalAvailable"
                [innerHTML]="capitalAvailable.availableForNewInvestments | rmsRoundRawNumber"></span>
          <img *ngIf="!editingCapitalAvailable" src="/assets/icons/pencil-icon-slim.svg" alt="edit"
               (click)="editCapitalAvailable(true)" (keydown)="editCapitalAvailable(true)"/>
          <img *ngIf="editingCapitalAvailable" src="/assets/icons/check-icon-slim.svg" alt="check"
               (click)="editCapitalAvailable(false); createOrUpdateCapitalAvailable(capitalAvailable)"
               (keydown)="editCapitalAvailable(false); createOrUpdateCapitalAvailable(capitalAvailable)"/>
          <img *ngIf="editingCapitalAvailable" src="/assets/icons/cancel-icon-slim.svg" alt="cancel" class="ml-2"
               (click)="editCapitalAvailable(false)" (keydown)="editCapitalAvailable(false)"/>
        </form>
      </div>
      <div class="card-body p-0 w-100">
        <div class="sticky-table">
          <table class="table table-striped darker-content no-border-left no-border-right">
            <thead>
            <tr>
              <th class="no-border-left">
                {{ "DASHBOARD.FUND" | translate }}
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.ABSOLUTE' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  {{ "DASHBOARD.ABSOLUTE" | translate }}
                </span>
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.TODAY_PERCENT' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  {{ "DASHBOARD.TODAY" | translate }}%
                </span>
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.YTD_PERCENT' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  YTD%
                </span>
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.MTD_PERCENT' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  MTD%
                </span>
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.QTD_PERCENT' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  QTD%
                </span>
              </th>
              <th>
                <span [ngbTooltip]="'FUND_SUMMARY.EXP' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  Exp
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.EXP_PROFITABLE' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  Exp In Profitable
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.EXP_CASH_BURNING' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  Exp In Cash Burning
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.WAMC' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  WAMC
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.WAEV' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  WAEV
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.WAYOC_CASH_BURNING' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  WAYOC Cash Burning
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.MEDIAN_MC' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  Median MC
                </span>
              </th>
              <th [hidden]="!displaySummaryDetails">
                <span [ngbTooltip]="'FUND_SUMMARY.MEDIAN_EV' | translate"
                      tooltipClass="rms-tooltip rms-tooltip-italic" container="body"
                      placement="top">
                  Median EV
                </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of intraDaySummaries">
              <td class="no-border-left text-left">
                <span [ngClass]="{'pl-2': item.name === '(Public)' || item.name === '(Private)',
                                  'pl-md-4': item.name === '(Public)' || item.name === '(Private)'}">
                  {{ item.name === '(Public)' || item.name === '(Private)' ? item.name.slice(1, -1) : item.name }}
                </span>
              </td>
              <td>
                <ng-container>
                  <span *ngIf="item.name === FUND_TYPES.COMMITTED_CASH" [innerHTML]="item.valueInUsd | rmsRoundRawNumber: true"></span>
                  <span *ngIf="item.name === FUND_TYPES.TOTAL" [innerHTML]="item.valueInUsd | rmsRoundRawNumber"
                        [ngbTooltip]="totalAUMTooltip | translate" tooltipClass="rms-tooltip" container="body" placement="top"></span>
                  <span *ngIf="item.name === FUND_TYPES.AUM" [innerHTML]="item.valueInUsd | rmsRoundRawNumber"
                        [ngbTooltip]="totalAUMTooltip | translate" tooltipClass="rms-tooltip" container="body" placement="top"></span>
                  <span *ngIf="item.name !== FUND_TYPES.COMMITTED_CASH && item.name !== FUND_TYPES.TOTAL && item.name !== FUND_TYPES.AUM"
                        [innerHTML]="item.valueInUsd | rmsRoundRawNumber"></span>
                </ng-container>
              </td>
              <td>
                <span
                    *ngIf="(item.name !== FUND_TYPES.COMMITTED_CASH) &&
                    (item.name !== FUND_TYPES.LONG_ACQUIRED) &&
                    (item.name !== FUND_TYPES.CASH) &&
                    (item.name !== FUND_TYPES.LONG_PRIVATE) &&
                    (item.name !== FUND_TYPES.TOTAL)"
                    [innerHTML]="item.dailyPercent | rmsNumberTransform"></span>
                <span *ngIf="(item.name === FUND_TYPES.TOTAL || item.name === FUND_TYPES.AUM)"
                      [innerHTML]="item.dailyPercentChange | rmsNumberTransform"></span>
              </td>
              <td>
                <span *ngIf="!(portfolioType === 'VENTURE' && item.name === FUND_TYPES.NAV)"
                      [innerHTML]="item.ytdPercentChange | rmsNumberTransform"></span>
              </td>
              <td>
                <span *ngIf="!(portfolioType === 'VENTURE' && item.name === FUND_TYPES.NAV)"
                      [innerHTML]="item.mtdPercentChange | rmsNumberTransform"></span>
              </td>
              <!-- Used in portfolio page -->
              <td>
                <span *ngIf="!(portfolioType === 'VENTURE' && item.name === FUND_TYPES.NAV)"
                      [innerHTML]="item.qtdPercentChange | rmsNumberTransform"></span>
              </td>
              <td>
                <ng-container *ngIf="!(portfolioType === 'VENTURE' && item.name === FUND_TYPES.NAV)">
                  <span *ngIf="item.name !== '(Public)' && item.name !== '(Private)'"
                      [innerHTML]="(item.exp | rmsNumberTransform: false: 1)"></span>
                  <span *ngIf="item.name === FUND_TYPES.LONG && longAcquiredFundSummary &&
                        longAcquiredFundSummary.valueInUsd > 0 && item.exp && longAcquiredFundSummary.exp"
                        style="font-size: 8px; margin-left: 4px" [ngbTooltip]="'Long Exposure - Long Acquired Exposure'"
                        tooltipClass="rms-tooltip rms-tooltip-italic" container="body" placement="top">
                    ({{ (item.exp - longAcquiredFundSummary.exp) | rmsNumberTransform: false: 1 }})
                  </span>
                  <span *ngIf="item.name === '(Public)' || item.name === '(Private)'"
                      [innerHTML]="(item.exp | rmsNumberTransform: false: 1) + '*' "></span>
                </ng-container>
              </td>

              <!-- Used in portfolio page -->
              <td [hidden]="!displaySummaryDetails">
                <span *ngIf="item.name !== '(Public)' && item.name !== '(Private)'"
                    [innerHTML]="(item.expInProfitable | rmsNumberTransform: false: 1)"></span>
                <span *ngIf="item.name === '(Public)' || item.name === '(Private)'"
                      [innerHTML]="(item.expInProfitable | rmsNumberTransform: false: 1) + '*' "></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span *ngIf="item.name !== '(Public)' && item.name !== '(Private)'"
                      [innerHTML]="(item.expInCashBurning | rmsNumberTransform: false: 1)"></span>
                <span *ngIf="item.name === '(Public)' || item.name === '(Private)'"
                      [innerHTML]="(item.expInCashBurning | rmsNumberTransform: false: 1) + '*' "></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span [innerHTML]="item.wamc | rmsFormatMoney: 'USD'"></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span [innerHTML]="item.waev | rmsFormatMoney: 'USD'"></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span [innerHTML]="item.wayocCashBurning | rmsNumberTransform: false: 3: ''"></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span [innerHTML]="item.medianMC | rmsFormatMoney: 'USD'"></span>
              </td>
              <td [hidden]="!displaySummaryDetails">
                <span [innerHTML]="item.medianEV | rmsFormatMoney: 'USD'"></span>
              </td>
            </tr>
            <!-- Index Companies -->
            <ng-container *ngIf="authorizationService.hasPermission([PERMISSIONS.CoreIndexCompanyRead])">
              <tr *ngFor="let indexCompany of sortedIndexCompanies; let i = index" [ngClass]="i === 0 ? 'index-company' : ''">
                <td class="no-border-left text-left">
                  <span>{{ indexCompany.name }}</span>
                  <span *ngIf="indexCompany.name.length < 4">&nbsp;</span>
                  <ng-container *ngIf="indexCompany.links && indexCompany.links.length > 0">
                    <a class="p-0" [href]="indexCompany.links[0].link.href" target="_blank">
                      <span class="rounded-icon m-0">Y</span>
                    </a>
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="authorizationService.hasPermission([PERMISSIONS.ReadMarketData])">
                    <span [innerHTML]="indexCompany.intradaySummary.valueInUsd | rmsNumberTransform: false: 2: '': 'USD'"
                          *ngIf="indexCompany.intradaySummary && (indexCompany.intradaySummary.valueInUsd !== null)"></span>
                  </ng-container>
                </td>
                <td>
                  <span [innerHTML]="indexCompany.intradaySummary.dailyPercentChange | rmsNumberTransform"
                        *ngIf="indexCompany.intradaySummary && (indexCompany.intradaySummary.dailyPercentChange !== null)"></span>
                </td>
                <td>
                  <span [innerHTML]="indexCompany.intradaySummary.ytdPercentChange | rmsNumberTransform"
                        *ngIf="indexCompany.intradaySummary && (indexCompany.intradaySummary.ytdPercentChange !== null)"></span>
                </td>
                <td>
                  <span [innerHTML]="indexCompany.intradaySummary.mtdPercentChange | rmsNumberTransform"
                        *ngIf="indexCompany.intradaySummary && (indexCompany.intradaySummary.mtdPercentChange !== null)"></span>
                </td>
                <!-- Used in portfolio page -->
                <td>
                  <span [innerHTML]="indexCompany.intradaySummary.qtdPercentChange | rmsNumberTransform"
                        *ngIf="indexCompany.intradaySummary && (indexCompany.intradaySummary.qtdPercentChange !==null)"></span>
                </td>
                <td></td>
                <!-- Used in portfolio page -->
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
                <td [hidden]="!displaySummaryDetails"></td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
      </div>
      <p class="footnote mt-1 mb-1">
        *Public and Private exposure values calculated using Long total instead of Fund total.
      </p>
    </div>
  </div>
</div>
<ng-template #permissionRequired>
  <rms-permission-lock-popover></rms-permission-lock-popover>
</ng-template>
